import AbstractUIActions from "../AbstractUIActions";
import {inject} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import IAudio from "../../engine/IAudio";
import Wallet from "../../wallet/Wallet";
import CommanderBase from "../../commander/CommanderBase";
import IStatesManager from "../../states/IStatesManager";
import {BASE_ELEMENT_IDS} from "../BaseDOM";
import * as Hammer from "hammerjs";
import events from "../../events/EventsObservable";
import {ACTION_EVENTS} from "../UserAction";
import DesktopDOM from "./DesktopDOM";
import KeydownHandler from "../KeydownHandler";
import SystemConfig, { CONFIG_PARAMS } from '../../system/SystemConfig'

export default class DesktopUIActions extends AbstractUIActions {

    private dom: DesktopDOM;
    protected config: SystemConfig

    constructor(
        @inject(SERVICE_IDENTIFIER.StatesManager) states: IStatesManager,
        @inject(SERVICE_IDENTIFIER.EngineAudio) audio: IAudio,
        @inject(SERVICE_IDENTIFIER.Wallet) wallet: Wallet,
        @inject(SERVICE_IDENTIFIER.Commander) commander: CommanderBase,
        @inject(SERVICE_IDENTIFIER.DOM) dom: DesktopDOM,
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig
    ) {

        super(states, audio, wallet, commander);
        this.config = config;
        this.dom = dom;
    }

    initKeys(): void {
        this.keydownHandler = new KeydownHandler(
			this.wallet,
			this,
			this.statesManager,
			this.audio
		);
		this.keydownHandler.initFromConfig(this.config.get(CONFIG_PARAMS.KEY_BINDINGS))
    }

    initTouch() {

        super.initTouch();

        this.initCanvasTouches(document.querySelector(`#${BASE_ELEMENT_IDS.GAME_WRAPPER} canvas`));

        let wintable = document.querySelector(`#${BASE_ELEMENT_IDS.WINTABLE_WRAPPER} canvas`);
        wintable && this.initCanvasTouches(wintable as HTMLElement);

        this.dom.setOnClick(this.click.bind(this));
    }

    private initCanvasTouches(element: HTMLElement) {
        let mc = new Hammer(element);

        mc.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
        mc.on("swipeleft", ev => {
            events.dispatch(ACTION_EVENTS.ACTION_GAME_CANVAS_SWIPE_LEFT, ev);
        });

        mc.on("swiperight", ev => events.dispatch(ACTION_EVENTS.ACTION_GAME_CANVAS_SWIPE_RIGHT, ev));
        mc.on("swipeup", ev => {
            events.dispatch(ACTION_EVENTS.ACTION_GAME_CANVAS_SWIPE_UP, ev);
        });
        mc.on("swipedown", ev => events.dispatch(ACTION_EVENTS.ACTION_GAME_CANVAS_SWIPE_DOWN, ev));
        mc.on("tap", ev => events.dispatch(ACTION_EVENTS.ACTION_GAME_CANVAS_TAP, ev));
    }
}